// scroll.js — drive the helix offset from the NATIVE scroll position,
// remapped to the .helixArea section: p=0 when the section pins at the top
// of the viewport, p=1 when its runway is spent. Native scrollTop is
// rock-solid and clamps at the limit, so no bounce. We keep the inertial
// "scrub" feel by lerping the offset toward the scroll target every frame.
import gsap from 'gsap';
import { TOTAL_OFFSET } from './helix.js';

const SCRUB = 0.085;        // lerp factor — lower = more inertia/lag
const EPS   = 0.00025;      // below this, treat as settled → stop rendering

export function initScroll(onUpdate, startOffset = 0, section = null) {
  const state = { offset: startOffset, target: startOffset, progress: 0 };
  let prev = null;

  gsap.ticker.add(() => {
    let p = 0;
    if (section) {
      // section-relative progress across the sticky runway
      const rect = section.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      p = total > 0 ? Math.min(Math.max(-rect.top / total, 0), 1) : 0;
    } else {
      const scroller = document.scrollingElement || document.documentElement;
      const max = scroller.scrollHeight - window.innerHeight;
      p = max > 0 ? Math.min(Math.max(scroller.scrollTop / max, 0), 1) : 0;
    }
    state.progress = p;
    state.target = startOffset + p * TOTAL_OFFSET;
    state.offset += (state.target - state.offset) * SCRUB;

    // on-demand render: only redraw while the offset is actually moving
    if (prev === null || Math.abs(state.offset - prev) > EPS) {
      onUpdate(state.offset);
      prev = state.offset;
    }
  });
  gsap.ticker.lagSmoothing(0);

  onUpdate(state.offset);   // first paint
  return { state };
}
